export const CLEAR_FORM_CONFIRM_TEXT = 'Вы уверены, что хотите очистить эту форму?';
